import { Button } from "@progress/kendo-react-buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { useContext } from "react";
import { toast } from "react-toastify";
import { InputChangeEvent } from "@progress/kendo-react-inputs/dist/npm/input/interfaces/InputChangeEvent";
import TextInput from "../../Layout/Inputs/TextInput";
import { EditProjectContext } from "./EditProjectContext";
import { ProjectState } from "../ViewModel/ProjectState";
import SaveProject from "./SaveProject";
import { InputButtonGroup } from "../../Layout/Inputs/InputButtonGroup";
import { useAddFtlRoute } from "./Hooks/useAddFtlRoute";
import { ReadOnlyProps } from "./ReadOnlyProps";

export default function AddRoute({ isReadOnly }: ReadOnlyProps) {
  const { project, reloadData } = useContext(EditProjectContext);
  const [routeNumber, setRouterNumber] = React.useState("");
  const addRouteRequest = useAddFtlRoute;

  const handleRouteNumberChanges = (event: InputChangeEvent) => {
    setRouterNumber(event.target.value as string);
  };

  const addFtlRoute = async (route: string | undefined) => {
    await SaveProject({ project });

    await addRouteRequest(project.ProjectId, route);
    reloadData();
  };

  return project.State !== ProjectState.Sandbox ? (
    <div />
  ) : (
    <InputButtonGroup>
      <TextInput
        texttransform="uppercase"
        label="Route Number"
        onChange={handleRouteNumberChanges}
        name="RouteNumber"
        disabled={isReadOnly}
      />
      <Button
        style={{ height: "30px", marginTop: "20px" }}
        disabled={routeNumber.length === 0 || isReadOnly}
        onClick={() =>
          toast.promise(addFtlRoute(routeNumber.toUpperCase()), {
            pending: "Adding Route in progress ",
            error: {
              render({ data }: { data: any }) {
                return `Error while adding route to project: ${data?.message}`;
              },
            },
            success: "Route has been added to project successfully",
          })
        }
      >
        <FontAwesomeIcon icon={faPlus} />
      </Button>
    </InputButtonGroup>
  );
}
